// Desktop Mega Menu
document.addEventListener('DOMContentLoaded', function() {
  if (window.matchMedia('(min-width: 768px)').matches) {
    const links = document.querySelectorAll('.mega-menu__link--level-2');

    function updateParentClass(parentList) {
      const hasActiveLink = Array.from(parentList.querySelectorAll('.mega-menu__link--level-2')).some(link =>
        link.classList.contains('active')
      );
      if (hasActiveLink) {
        parentList.classList.add('has-active-link');
      } else {
        parentList.classList.remove('has-active-link');
      }

      updateBodyClass();
    }

    function updateBodyClass() {
      const anyActiveLink = document.querySelectorAll('.mega-menu__link--level-2.active').length > 0;
      if (anyActiveLink) {
        document.body.classList.add('mega-menu-active');
      } else {
        document.body.classList.remove('mega-menu-active');
      }
    }

    links.forEach(link => {
      const parentList = link.closest('.mega-menu__list');

      link.addEventListener('mouseover', function() {
        const activeSubMenus = parentList.querySelectorAll('.mega-menu-sub.active');
        activeSubMenus.forEach(subMenu => {
          subMenu.classList.remove('active');
        });

        const activeLinks = parentList.querySelectorAll('.mega-menu__link--level-2.active');
        activeLinks.forEach(activeLink => {
          activeLink.classList.remove('active');
        });

        const subMenu = this.nextElementSibling;

        if (subMenu && subMenu.classList.contains('mega-menu-sub')) {
          subMenu.classList.add('active');
        }

        this.classList.add('active');
        updateParentClass(parentList);
      });

      link.addEventListener('mouseout', function() {
        const subMenu = this.nextElementSibling;

        if (subMenu && subMenu.classList.contains('mega-menu-sub')) {
          subMenu.classList.remove('active');
        }
        this.classList.remove('active');
        updateParentClass(parentList);
      });

      const subMenu = link.nextElementSibling;
      if (subMenu && subMenu.classList.contains('mega-menu-sub')) {
        subMenu.addEventListener('mouseover', function() {
          this.classList.add('active');
          link.classList.add('active');
          document.querySelector('.header__inline-menu details.mega-menu').setAttribute('open', true);
          updateParentClass(parentList);
        });
        subMenu.addEventListener('mouseout', function() {
          this.classList.remove('active');
          link.classList.remove('active');
          document.querySelector('.header__inline-menu details.mega-menu').setAttribute('open', false);
          updateParentClass(parentList);
        });
      }

      link.addEventListener('click', function(event) {
        window.location.href = this.href;
      });
    });

    document.querySelectorAll('.mega-menu__list').forEach(parentList => {
      updateParentClass(parentList);
    });
  } else {
    const menuItems = document.querySelectorAll('.menu-drawer__menu__links-main');
    menuItems.forEach(function(menuItem) {
      if (!menuItem.nextElementSibling || !menuItem.nextElementSibling.classList.contains('mega-menu-sub')) {
        const links = menuItem.querySelectorAll('a');

        links.forEach(function(link) {
          link.addEventListener('click', function(event) {
            event.preventDefault();
            if (link.getAttribute('target') === '_blank') {
              window.open(this.getAttribute('href'), '_blank');
            } else {
              window.location.href = this.getAttribute('href');
            }
          });
        });
      }
    });
  }
});

// Menu Border Animation
document.addEventListener('DOMContentLoaded', function() {
  var menuItems = document.querySelectorAll('.list-menu li');
  var border = document.querySelector('.border');

  for (var i = 0; i < menuItems.length; i++) {
    menuItems[i].addEventListener('mouseover', function() {
      var item = this.querySelector('.list-menu__item > span');
      if (item) {
        var itemRect = item.getBoundingClientRect();
        var menuRect = this.parentNode.getBoundingClientRect();
        var leftPos = itemRect.left - menuRect.left;
        var width = itemRect.width;
        if (border) {
          border.style.transform = 'translateX(' + leftPos + 'px)';
          border.style.width = width + 'px';
        }
      }
    });
    menuItems[i].addEventListener('mouseout', function() {
      if (border) {
        border.style.width = '39.9375' + 'px';
        border.style.transform = 'translateX(' + 20 + 'px)';
      }
    });
  }
});

document.addEventListener('DOMContentLoaded', function() {
  var border = document.querySelector('.border');
  var item = document.querySelector('.list-menu li:first-child .list-menu__item > span');
  if (item) {
    var itemRect = item.getBoundingClientRect();
    var width = itemRect.width;

    if (border) {
      border.style.transform = 'translateX(' + 20 + 'px)';
      border.style.width = width + 'px';
    }
  }
});

// Header Search
document.addEventListener('DOMContentLoaded', function() {
  const searchIcon = document.querySelector('.header__icon--search-mobile');
  let activeSearchWrapper = null;

  function getSearchWrapper() {
    var mediaBreakpoint = 992;
    if (searchIcon && searchIcon.classList.contains('js-jackson-search')) {
      mediaBreakpoint = 1150;
      const searchContainer = document.querySelector('.boost-sd__instant-search-container');
      if (searchContainer) {
        searchContainer.classList.add('jackson-search-modal');
      }
      const mobileContainer = document.querySelector('.boost-sd__instant-search-container-mobile');
      if (mobileContainer) {
        mobileContainer.style.display = 'block';
      }

      const buttonTextX = document.querySelector('.boost-sd__button-text-x');
      if (buttonTextX) {
        buttonTextX.addEventListener('click', function() {
          const searchBarWrapper = document.querySelector(
            '.boost-sd__instant-search-container-mobile .boost-sd__search-bar-wrapper'
          );
          if (searchBarWrapper) {
            searchBarWrapper.classList.add('boost-sd__g-hide');
          }
        });
      }
    }
    if (window.innerWidth < mediaBreakpoint) {
      return document.querySelector('.boost-sd__instant-search-container-mobile .boost-sd__search-bar-wrapper');
    } else if (window.innerWidth >= 992 && window.innerWidth <= 1150) {
      return document.querySelector('.boost-sd__instant-search-container-desktop .boost-sd__search-bar-wrapper');
    }
    return null;
  }

  function setupSearchToggle() {
    if (searchIcon && activeSearchWrapper) {
      searchIcon.removeEventListener('click', toggleSearchWrapper);
    }
    activeSearchWrapper = getSearchWrapper();
    if (searchIcon && activeSearchWrapper) {
      searchIcon.addEventListener('click', toggleSearchWrapper);
    }
  }

  function toggleSearchWrapper() {
    if (activeSearchWrapper) {
      activeSearchWrapper.classList.toggle('boost-sd__g-hide');
    }
  }

  const observer = new MutationObserver(() => {
    const searchWrapper = getSearchWrapper();
    if (searchWrapper) {
      setupSearchToggle();
      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
  window.addEventListener('resize', setupSearchToggle);
  setupSearchToggle();
});

document.addEventListener('DOMContentLoaded', function() {
  const menuDrawer = document.getElementById('menu-drawer');
  const hamburgerIcon = document.querySelector('.icon-hamburger');
  const html = document.querySelector('html');

  if (menuDrawer && menuDrawer.style.display === '') {
    menuDrawer.style.display = 'none';
  }

  if (hamburgerIcon) {
    hamburgerIcon.addEventListener('click', function() {
      const isMenuVisible = menuDrawer.style.display === 'block';

      if (!isMenuVisible) {
        slideDown(menuDrawer, 200);
      } else {
        slideUp(menuDrawer, 500);
        html.classList.remove('overflow-y-hidden');
      }
    });
  }

  function slideDown(element, duration) {
    element.style.display = 'block';
    element.style.height = 0;
    element.style.overflow = 'hidden';
    element.classList.add('drawer-active');

    anime({
      targets: element,
      height: element.scrollHeight,
      duration: duration,
      easing: 'easeInOutQuad',
      complete: function(anim) {
        element.style.height = 'calc(var(--viewport-height, 100vh) - (var(--header-bottom-position, 100%)))';
      }
    });
  }

  function slideUp(element, duration) {
    element.style.height = element.scrollHeight + 'px';
    element.style.overflow = 'hidden';
    element.classList.remove('drawer-active');

    anime({
      targets: element,
      height: 0,
      duration: duration,
      easing: 'easeInOutQuad',
      complete: function(anim) {
        element.style.display = 'none';
      }
    });
  }
});
